import React, { useEffect, useState } from "react";
import AppSidebar from "./AppSidebar";
import AppContentView from "@crema/core/AppContentView";
import AppThemeSetting from "../../AppThemeSetting";
import AppHeader from "./AppHeader";
import clsx from "clsx";
import Box from "@mui/material/Box";
import MiniSidebarToggleWrapper from "./MiniSidebarToggleWrapper";
import AppFixedFooter from "./AppFixedFooter";
import { useLayoutContext } from "../../../utility/AppContextProvider/LayoutContextProvider";
import { LayoutType } from "shared/constants/AppEnums";
import MiniSidebarToggleContainer from "./MiniSidebarToggleContainer";
import AppInfoView from "@crema/core/AppInfoView";
import { useLocation } from "react-router-dom";

const MiniSidebarToggle = () => {
    const [isCollapsed, setCollapsed] = useState(true);
    const { footer, layoutType, headerType, footerType } = useLayoutContext();
    const location = useLocation();

    useEffect(() => {
        const pageBody = document.getElementsByTagName("body")[0];
        const iframeWidget = document.getElementById("panchangwidgetid");
        const sidebarElement = document.getElementsByClassName(
            "mini-sidebar-collapsed"
        );
        if (iframeWidget !== null) {
            if (location.pathname === "/event/panchang") {
                pageBody.style.overflow = "hidden";
                iframeWidget.style.display = "block";
                iframeWidget.style.transition = "all 0.3s ease";
                if (sidebarElement.length === 0) {
                    iframeWidget.style.left = "310px";
                } else {
                    iframeWidget.style.left = "20px";
                }
            } else {
                pageBody.style.overflow = "initial";
                iframeWidget.style.display = "none";
            }
        }
    }, [isCollapsed, location]);

    return (
        <MiniSidebarToggleContainer
            className={clsx({
                boxedLayout: layoutType === LayoutType.BOXED,
                framedLayout: layoutType === LayoutType.FRAMED,
            })}
        >
            <MiniSidebarToggleWrapper
                className={clsx("miniSidebarToggleWrapper", {
                    "mini-sidebar-collapsed test": isCollapsed,
                    appMainFooter: footer && footerType === "fluid",
                    appMainFixedFooter: footer && footerType === "fixed",
                    appMainFixedHeader: headerType === "fixed",
                })}
            >
                <AppHeader
                    setCollapsed={setCollapsed}
                    isCollapsed={isCollapsed}
                />
                <AppSidebar />
                <Box className="mainContent">
                    <AppContentView />
                    <AppFixedFooter />
                    <AppInfoView />
                </Box>

                <AppThemeSetting />
            </MiniSidebarToggleWrapper>
        </MiniSidebarToggleContainer>
    );
};

export default MiniSidebarToggle;
